import api from '../utils/request'

export default {
  // 列表 + 组合查询：department / device_name / factory_no(精确) / report_time / expire_date / conclusion
  list(params) {
    return api.get('/report-reminder/site-performance/', { params })
  },
  // 列表顶部汇总：已过期 / 30 天内到期 / 合计（跟随当前筛选条件，不分页）
  stats(params) {
    return api.get('/report-reminder/site-performance/stats/', { params })
  },
  // 新增（含场所单报告 + 性能多报告，FormData）
  create(data) {
    return api.post('/report-reminder/site-performance/', data)
  },
  // 编辑（含可选报告替换，FormData）
  update(id, data) {
    return api.put(`/report-reminder/site-performance/${id}/`, data)
  },
  // 删除：后端把硬盘文件移入「删除」文件夹，再删记录
  delete(id) {
    return api.delete(`/report-reminder/site-performance/${id}/`)
  },
  // 归档（重新检测）：移动旧报告到归档目录并按规范命名，更新报告时间，存入新报告
  archive(id, data) {
    return api.post(`/report-reminder/site-performance/${id}/archive/`, data)
  },
  // 识别报告：上传场所/性能报告 PDF，自动提取最大管电压/最大管电流供表单回填
  // 扫描件需 PDF 渲染 + RapidOCR，多页报告常超过 30s，单独放宽超时到 3 分钟
  extractPdf(data) {
    return api.post('/report-reminder/site-performance/extract-pdf/', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 180000,
    })
  },
  // 查看归档记录：列出本条记录在硬盘「归档」文件夹中的历史报告文件
  archiveFiles(id) {
    return api.get(`/report-reminder/site-performance/${id}/archive-files/`)
  },
  // 获取所选记录可导出报告的所有年份（含当前报告 + 已归档报告），用于导出弹窗动态渲染年份多选框
  availableYears(ids) {
    return api.get('/report-reminder/site-performance/available-years/', {
      params: { ids: ids.join(',') },
    })
  },
  // 导出报告 PDF（场所报告 + 性能报告）：按选中的记录 ID + 年份筛选，后端打包成 ZIP 下载
  exportFiles(data) {
    return api.post('/report-reminder/site-performance/export-files/', data, {
      responseType: 'blob',
      timeout: 120000,
    })
  },
}
